import { render, staticRenderFns } from "./Soal.vue?vue&type=template&id=26920818&"
import script from "./Soal.vue?vue&type=script&lang=js&"
export * from "./Soal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports